import { type ForwardedRef, forwardRef } from 'react';

import { EmployeeIdType } from '@/common/graphql';
import { EmployeeIdTypeLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

import type { ComboboxItemWithFormatted } from '../props';
import { SelectSingle, type SelectSingleProps } from '../SelectSingle';

interface EmployeeIdTypeSelectSingleProps
  extends Omit<SelectSingleProps<ComboboxItemWithFormatted<EmployeeIdType>>, 'searchable' | 'value'> {
  value: EmployeeIdType | null;
}

const data = ObjectUtils.arrayFromEnumValues<EmployeeIdType>(EmployeeIdType).map(value => ({
  label: EmployeeIdTypeLabels[value],
  value,
}));

export const EmployeeIdTypeSelectSingle = forwardRef(
  ({ placeholder = 'Select ID type', ...rest }: EmployeeIdTypeSelectSingleProps, ref: ForwardedRef<HTMLDivElement>) => (
    <SelectSingle ref={ref} {...rest} data={data} loading={false} placeholder={placeholder} />
  ),
);
